import { metricsStore } from '@globalStore/metricsStore';
import { FLOW_ERROR_ANALYSIS_ONLY_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import { DIMENSION_CATEGORY_KEYS } from '@utils/dimension/dimensionCategories';
import { exclusiveFrustrationSignalDimension } from './defaultExcludes';

export const createEventPresetLimitations = () => {
  const { metricsCategoryKeys, eventConfigMeta } = metricsStore.getState();
  if (!eventConfigMeta) return {};

  return {
    event: {
      context: {
        type: 'event',
        id: 'signal_event',
      },
      metrics: {
        excludeTypes: [],
        excludeKeys: [],
        excludeCategories: [
          metricsCategoryKeys.ECO_QOE,
          metricsCategoryKeys.ECO_SERVICE_PERFORMANCE,
          metricsCategoryKeys.ECO_USER_DEFINED_METRICS,
          metricsCategoryKeys.ECO_FRUSTRATION_SIGNALS,
        ],
        config: {
          createCustomMetric: false,
          createFlowMetric: false,
          showPercentile: false,
          showFlow: false,
        },
      },
      dimensions: {
        excludeTypes: [...FLOW_ERROR_ANALYSIS_ONLY_DIMENSIONS],
        excludeKeys: [],
        excludeCategories: [
          DIMENSION_CATEGORY_KEYS.eco.network,
          DIMENSION_CATEGORY_KEYS.eco.events,
          ...exclusiveFrustrationSignalDimension,
        ],
      },
      dimensionPanel: {
        networkRequestTab: {
          disabled: true,
        },
      },
      summaryMetricPanel: {},
    },
  };
};
